import React from 'react';
import { LocaleProvider } from 'antd';
import { render } from 'react-snapshot';
import './index.css';
import Frame from './Frame';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import enUS from 'antd/lib/locale-provider/en_US';
import FastClick from 'fastclick';

FastClick.attach(document.getElementById('root'));

render(
  <BrowserRouter>
    <LocaleProvider locale={enUS}>
      <Frame />
    </LocaleProvider>
  </BrowserRouter>, document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js